// Wrappers de la nómina para Administración · Contratistas (plan
// 2026-10-30 §2.6, T-0qrc). Los tres endpoints (GET/POST /providers,
// PATCH /providers/:id) ya viven en lib/api/endpoints/providers.ts, que
// también alimenta al drawer de asignación; aquí sólo se juntan bajo el
// nombre de la sección, al estilo de mantenciones/api.ts, para que la
// pantalla y sus tests hablen de un solo objeto.

import type { ProviderCreateBody, ProviderPatchBody } from "@bitacorapro/api-types";
import { createProvider, listProviders, patchProvider } from "../../../lib/api/endpoints/providers";

export const contratistasApi = {
  // GET /providers — activos y pausados por igual; la pantalla muestra
  // ambos con su pill de estado.
  list: () => listProviders(),
  // POST /providers — `created: false` cuando el nombre ya existía y la
  // fila se reusó.
  create: (body: ProviderCreateBody) => createProvider(body),
  // PATCH /providers/:id — ficha (sólo lo que cambió) o estado.
  patch: (id: string, body: ProviderPatchBody) => patchProvider(id, body),
};
